module.exports = __webpack_public_path__ + "img/Klevaar.9495d1f5.svg";